__turbopack_context__.v({
  "search_filter_input": "SearchInput-module-scss-module__rTDQ8W__search_filter_input",
  "text_input": "SearchInput-module-scss-module__rTDQ8W__text_input",
  "text_input_clear_button": "SearchInput-module-scss-module__rTDQ8W__text_input_clear_button",
  "text_input_icon": "SearchInput-module-scss-module__rTDQ8W__text_input_icon",
});
